import React from "react";
import P2BGImage from "../../../assets/roofing-reports-assets/page2-bg.png";
import "./styles.scss";

const Page2 = ({ anomalies, wind_damage, hail_detection, buildingImg }) => {
  return (
    <div className="shadow py-2 pb-5 mt-3">
      <div className="p2-page-rule">
        <span> Roof Damage</span>
        <span> 1</span>
      </div>
      <div className="p2-page-title">
        <h3>YOUR ROOF DAMAGE </h3>
      </div>
      <div className="p2-page-data">
        <div className="p2-page-data__datum-1">
          <h6> {hail_detection !== 0 ? hail_detection : "N/A"} </h6>

          <span> Hail Impacts</span>
        </div>
        <div className="p2-page-data__datum-2">
          <h6> {anomalies !== 0 ? anomalies : "N/A"} </h6>
          <span> Roof Anomalies </span>
        </div>
        <div className="p2-page-data__datum-3">
          <h6> {wind_damage === 0 ? "N/A" : wind_damage} </h6>
          <span> Wind Damages</span>
        </div>
      </div>
      <div
        style={{
          background: `url(${buildingImg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
        className="p2-bg"
      ></div>
    </div>
  );
};

export default Page2;
